module.exports = __webpack_public_path__ + "static/img/changJingImg1.a6b7176.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/changJingImg1.png
// module id = KSjG
// module chunks = 2